import { put } from 'redux-saga/effects';
import { homePageSetInStoreAction } from 'pages/home.page/actions';
import { errorHandleAction } from 'components/error-handle/actions';
import { fetchHomeConfigApi } from 'common/api/home';

export function* homepageRequestEffect() {
  try {
    // Get configured channels from API
    const homeConfig = yield fetchHomeConfigApi();

    // send action to homepage reducer
    yield put(homePageSetInStoreAction(homeConfig.videoLists));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
